import React, { ReactNode } from "react";
import { View, Pressable } from "react-native";
import { Text } from "../Text";
import { footerButtonStyles as styles } from "./styles";

interface FooterButtonProps {
  text: ReactNode;
  onPress: () => void;
  disabled?: boolean;
  testID?: string;
}

const FooterButton: React.FC<FooterButtonProps> = ({
  text,
  onPress,
  disabled = false,
  testID,
}) => (
  <View style={styles.container}>
    <Pressable
      testID={testID}
      accessibilityRole="button"
      accessibilityState={{ disabled }}
      disabled={disabled}
      onPress={onPress}
      style={[styles.button, disabled && styles.disabledButton]}
    >
      {typeof text === "string" ? (
        <Text style={styles.buttonText}>{text}</Text>
      ) : (
        text
      )}
    </Pressable>
  </View>
);

export default FooterButton;
